import { CardBackgroundColorType, GradientType } from '~types'

type LayoutDirection = 'horizontal' | 'vertical'

const COLOR_MAP: Record<CardBackgroundColorType, string> = {
  tealDark: '#003C4E',
  pinkLight: '#E86DB2',
  greenLight: '#7CCC6C',
  dark: '#353535',
  gold: '#41361D',
  purple: '#352036',
  transparent: 'transparent'
}

const GRADIENTS = {
  horizontal: {
    radial_gradient: {
      belowBreakpoint: `radial-gradient(74.4% 79.93% at 100% 100%, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0) 100%),
        linear-gradient(174deg, #000 13.09%, {color} 96.05%)`,
      withMediaRight: `radial-gradient(15% 0% at 0% 100%, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0) 100%),
        linear-gradient(90deg, {color} 0%, #000000 90%)`,
      default: `radial-gradient(54.35% 68.23% at 100% 100%, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0) 100%),
        linear-gradient(100deg, #000 -2.38%, {color} 71.5%)`
    },
    linear_gradient: `linear-gradient(180deg, rgba(0, 0, 0, 0.15) 0%, {color} 100%)`,
    frosted_glass: `rgba(0, 0, 0, 0.1)`,
    transparent: 'transparent'
  },
  vertical: {
    radial_gradient: `radial-gradient(78.47% 68.23% at 100% 100%, rgba(255, 255, 255, 0.15) 0%, {color} 100%)`,
    linear_gradient: `linear-gradient(173.92deg, #000000 13.09%, {color} 96.05%)`,
    frosted_glass: `rgba(0, 0, 0, 0.1)`,
    transparent: 'transparent'
  }
}

type Props = {
  gradient?: GradientType
  color?: CardBackgroundColorType
  overrideColor?: CardBackgroundColorType | null
  direction: LayoutDirection
  isBelowBreakpoint?: boolean
  hasMediaInRightColumn?: boolean
}

export const getBackgroundGradient = ({
  gradient,
  color,
  overrideColor,
  direction = 'horizontal',
  isBelowBreakpoint,
  hasMediaInRightColumn
}: Props): string | null => {
  if (!gradient || !color) return COLOR_MAP.transparent
  const gradientConfig = GRADIENTS[direction][gradient]
  const baseColor = overrideColor ? COLOR_MAP[overrideColor] : COLOR_MAP[color]
  if (gradient === 'transparent') return gradientConfig as string

  if (typeof gradientConfig === 'object') {
    // Handle horizontal radial_gradient cases
    if (isBelowBreakpoint) return gradientConfig.belowBreakpoint.replace('{color}', baseColor)
    if (hasMediaInRightColumn) return gradientConfig.withMediaRight.replace('{color}', baseColor)
    return gradientConfig.default.replace('{color}', baseColor)
  }

  return gradientConfig.replace('{color}', baseColor)
}
